import React from 'react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import './StateDisclosure.scss'

export default function StateDisclosure() {
    const tableStyle = { border: '1px solid rgba(224, 224, 224, 1)' }
    const tableMainHeadStyle = { backgroundColor: '#7E7E7E', color: 'white', textAlign: 'center' }
    const tableHeadStyle = { border: '1px solid rgba(224, 224, 224, 1)', textAlign: 'center' }

    return (
        <div className="state-disclosure">
            <TableContainer>
                <Table style={tableStyle} aria-label="State License Disclosure">
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ ...tableHeadStyle, ...tableMainHeadStyle }} colSpan={1}>
                                State
                                </TableCell>
                            <TableCell style={{ ...tableHeadStyle, ...tableMainHeadStyle }} colSpan={1}>
                                License #
                                </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">AL</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">0783259</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">AK</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">100141923</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">AZ</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">1175591</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">AR</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">3000074001</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">CA</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">0L77229</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">CO</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">532851</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">CT</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">2551636</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">DC</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">3000073987</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">DE</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">3000067942</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">FL</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">L099678</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">GA</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">194472</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">HI</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">451231</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">ID</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">607086</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">IL</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">3000078371</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">IN</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">3225101</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">IA</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">1002287899</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">KS</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">813686767-000</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">KY</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">948084</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">LA</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">724500</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">ME</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">AGN283495</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">MD</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">3000073999</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">MA</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">2027441</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">MI</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">0112074</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">MN</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">40514835</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">MS</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">15031165</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">MO</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">8409226</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">MT</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">3000073992</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">NE</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">100264901</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">NV</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">3225020</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">NH</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">2364248</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">NJ</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">1635336</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">NM</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">100015168</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">NY</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">1475074</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">NC</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">1000517981</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">ND</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">3000073983</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">OH</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">1140517</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">OK</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">100287002</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">OR</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">3000087663</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">PA</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">805968</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">RI</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">3000081962</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">SC</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">211633</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">SD</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">1019526</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">TN</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">2359992</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">TX</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">2188156</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">UT</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">608655</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">VT</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">3231259</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">VA</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">141432</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">WA</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">945321</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">WV</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">100239073</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">WI</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">3000073996</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableHeadStyle} component="th" scope="row">WY</TableCell>
                            <TableCell style={tableHeadStyle} component="th" scope="row">333377</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Disclosure/StateDisclosure.js